<mat-form-field style="width: 100%" [formGroup]="form" appearance="outline" >
	<mat-label>{{item.label}}</mat-label>  
	<input matInput [placeholder]="item.label" [matAutocomplete]="auto" [formControlName]="item.name"  (change)="handleEmptyInput($event)" [required]="item.required">
	<button #iconButton *ngIf="item.icon" matSuffix color="primary" mat-icon-button type="button" (click)="onClick($event)">
	  <mat-icon>{{item.icon_type}}</mat-icon>
	</button>
	<!-- autoActiveFirstOption  bu auto complatei direk acilir halde sunuyor -->
	<mat-autocomplete autoActiveFirstOption="false" #auto="matAutocomplete" [displayWith]="valueMapper" (optionSelected)="onSelected($event)">
		<mat-option *ngFor="let opt of filteredOptions | async" [value]="opt.data" (click)="matInput.value=''">
		  {{opt.label}}
		</mat-option>
	  </mat-autocomplete>
  </mat-form-field>